import { Component } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TranslationHelperService } from '../../../services/translation-helper.service';

interface Language {
  code: string;
  name: string;
}

@Component({
  selector: 'app-language-switcher-popover',
  template: `
    <ion-list lines="none" style="max-width: 200px">
      <ion-item
        *ngFor="let lang of languages"
        (click)="switchLanguage(lang.code)"
        [class.active]="currentLang === lang.code"
        style="cursor: pointer">
        <ion-label>
          <ion-icon name="checkmark" *ngIf="currentLang === lang.code" color="primary"></ion-icon>
          {{ lang.name }}
        </ion-label>
      </ion-item>
    </ion-list>
  `,
  styles: [`
    .active {
      --background: var(--ion-color-light);
      --color: var(--ion-color-primary);
    }

    ion-item {
      --padding-start: 16px;
      --padding-end: 16px;
      --min-height: 44px;
    }

    ion-label {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    ion-icon {
      font-size: 18px;
    }
  `]
})
export class LanguageSwitcherPopoverComponent {
  currentLang: string;
  languages: Language[] = [];

  constructor(
    private popoverController: PopoverController,
    private translationHelper: TranslationHelperService
  ) {
    this.loadLanguageData();
  }

  private loadLanguageData() {
    this.currentLang = this.translationHelper.getCurrentLanguage();

    this.languages = this.translationHelper.getAvailableLanguagesWithNames();

    if (this.languages.length === 0) {
      this.languages = [
        { code: 'en', name: 'English' }
      ];
    }
  }

  async switchLanguage(lang: string) {
    if (lang === this.currentLang) {
      this.popoverController.dismiss();
      return;
    }

    try {
      const success = await this.translationHelper.switchLanguage(lang);

      if (success) {
        this.currentLang = lang;
        this.popoverController.dismiss(lang);
        window.location.reload();
      } else {
        this.popoverController.dismiss();
      }
    } catch (error) {
      this.popoverController.dismiss();
    }
  }
}